function RoomView({color, children}) {
    return (<>
        <div className="content-center brand">
            {children}
        </div>
    </>)
}

export default RoomView